import {Injectable} from '@angular/core';
import {FilterControl} from '../interface/filter-control';

@Injectable({
	providedIn: 'root'
})
export class SetQuaryParamService {

	constructor() { }

	// public gsmMaxValue = 0;
	// public priceMaxValue = 0;
	public url: string = '';


	public prepareUrl(controls: FilterControl): string {
		this.url = '?';
		// this.gsmMaxValue = controls['rangeFilterControls'][0].values.max; //default gsm value
		// this.priceMaxValue = controls['rangeFilterControls'][1].values.max; //default price value
		// console.log(controls);
		let quaryParm = '';
		Object.entries(controls).forEach((keys, i: number) => {
			// console.log(keys[0]);
			quaryParm = this.setUrl(controls, keys[0], i, Object.keys(controls).length);
		});
		return quaryParm
	}

	public setUrl(controls: any, key: any, controlIndex: number, controlLength: number): string {

		if (key == 'normalFilterControls') {

			let dynamicControl = controls[key];

			dynamicControl.forEach((dc: any) => {

				if (this.checkIfKeyHasChecked(dc['options'])) {

					this.url = this.url + dc.name + '=';

					dc['options'].forEach((element: any, i: number) => {

						if (element.activated) {
							if (i > 0) this.url = this.url + ',';
							this.url = this.url + element.name;
						}

					});
				}
			});

		}

		if (key == 'colorFilterControls') {

			let dynamicControl = controls[key];

			dynamicControl.forEach((dc: any) => {
				if (this.checkIfKeyHasChecked(dc['options'])) {

					if (this.url.includes('=')) this.url = this.url + '&';

					this.url = this.url + dc.name + '=';
					dc['options'].forEach((element: any, i: number) => {

						if (element.activated) {
							if (i > 0) this.url = this.url + ','
							this.url = this.url + element.name;

						}

					});
				}
			});
		}

		if (key == 'rangeFilterControls') {
			let dynamicControl = controls[key];

			dynamicControl.forEach((range: any) => {

				if (range.key == 'gsm') {
					if (range.values.value1 >= 0 || range.values.value2 >= 0) {
						this.url = this.url + '&' + range.key + '=' + 'min-' + range.values.value1;
						this.url = this.url + 'and_max-' + range.values.value2;
					}
					if (this.url.includes('?&gsm')) this.url = this.url.replace('&gsm', 'gsm');
				}

				if (range.key == 'price') {
					if (range.values.value1 >= 0 || range.values.value2 >= 0) {
						this.url = this.url + '&' + range.key + '=' + 'min-' + range.values.value1;
						this.url = this.url + 'and_max-' + range.values.value2;
					}
					if (this.url.includes('?&price')) this.url = this.url.replace('&price', 'price');
				}

				if (range.key == 'quantity') {
					if (range.values.value1 >= 0 || range.values.value2 >= 0) {
						this.url = this.url + '&' + range.key + '=' + 'min-' + range.values.value1;
						this.url = this.url + 'and_max-' + range.values.value2;
					}
					if (this.url.includes('?&quantity')) this.url = this.url.replace('&quantity', 'quantity');
				}

			})

		}

		if (key == 'singleFilterControls') {
			// debugger
			// console.log(controls)
			if(!controls.singleFilterControls[0].options) this.url = this.url + '&no_stock'
			else this.url = this.url.replace("&no_stock","");

		}


		if (this.url.includes('materials') && this.url.includes('patterns')) {
			if (controlIndex == (controlLength - 1)) {
				this.url = this.url.replace('patterns', '&patterns');
			}
		}

		if (this.url.includes('=,')) this.url = this.url.replace("=,", "=")

		return this.url
	}


	public checkIfKeyHasChecked(arr: any) {
		return arr.some(function (el: any): boolean {
			return el.activated;
		});
	}

}
